module.exports = __webpack_public_path__ + "img/image 2432.8b65fbe7.png";